@if(product){
@if(!isSM){

<product-view-details-name [content]="content"
                           [product]="product"></product-view-details-name>
}

@if (product.data?.is_cartable) {
<product-view-price class="m-t block wrap-s wrap-m"></product-view-price>
} @else {
<p class="h2 m-t wrap-s wrap-m">{{'Call us for pricing' | translate}}</p>
}

@if (productConfiguration.type === 'configurable') {
<product-view-configurable-options class="block"
                                   [content]="content"></product-view-configurable-options>
}

<!-- @if (productConfiguration.hasCustomOptions) {
<product-view-custom-options></product-view-custom-options>
} -->
<div class="wrap-s wrap-m">

    @if(isQuote){
    <product-view-details-quote class="w-12 m-t"
                                [product]="product"></product-view-details-quote>
    } @else {

    @if(product?.moq && product.moq > 1){
    <div class="p2 m-t">
        {{'There is a Minimum Order Quantity (MOQ) of % for this item.' | translate : product.moq}}
    </div>
    }

    <product-view-qty-select [max]="9999"
                             [(model)]="qty"
                             [min]="product?.moq || 1"
                             [step]="product?.qtyIncrements || 1"
                             class="inline-block m-t m-t-8-s m-t-8-m"
                             (modelChange)="detectChanges()">
    </product-view-qty-select>

    @if(variationDescription){
    <div class="p2 m-t"
         [innerHtml]="variationDescription">
    </div>
    }

    <div [grid]="buttonsGridSize"
         [gridColumnGap]="'8px'"
         [gridRowGap]="'8px'"
         class="m-t-8">
        <product-view-add-to-basket class="w-12"
                                    [isDisabled]="addToBasketDisabled"
                                    [gridColumn]="1"
                                    (addedToBasket)="onAddedToBasket()"
                                    cy-ppAddToBasketButton></product-view-add-to-basket>
        @if(isArtPanel){
        <product-view-pitch-print-button [gridColumn]="1"
                                         (projectSaved)="onProjectSaved($event)"
                                         [project]="currentProject"
                                         [product]="product"
                                         class="w-12"></product-view-pitch-print-button>

        }
    </div>

    @if(currentProject){
    <div class="center p-t-2 p-b-">
        <button inlineButton
                class="va-m s1"
                (click)="downloadPdf()"
                cy-basketRemove>{{'Download PDF' | translate}}</button>
    </div>
    }


    @if(leadTime){

    <div class="p2 p-r p-l p-t-1 p-b-1 m-t-2 center"
         [innerHtml]="leadTime">
    </div>
    }
    }

    <product-view-details-bottom-list class="block"
                                      [content]="content"
                                      [product]="product" />
</div>
}